import { Grid } from "@mui/material"


import './index'
import { useCallback, useState } from "react";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import { EMPLOYEE_LOANS_THREE, EMPLOYEE_LOANS_TWO } from "../../../constants/signalRequestConsts";
import TableLoans from "../documents/TableLoans";
import FormRequest from "./FormRequest";

const getDefaultDate = (months: number) => {
    const newDate = new Date();
    newDate.setMonth(newDate.getMonth() + months);
    return newDate;
}

const Loans = () => {
    // const [refreshTime, setRefreshTime] = useState(new Date());
    const [refreshKey, setRefreshKey] = useState(0);

    const forceRefresh = useCallback(() => {
        setRefreshKey(prev => prev + 1);
    }, []);

    const ComponentOne = useCallback(() => (
        <FormRequest 
            key={`form-${refreshKey}`}
            refreshKey={refreshKey}
            // setRefreshTime={setRefreshTime}
            forceRefresh={forceRefresh}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [refreshKey, forceRefresh]);
    
    const ComponentTwo = () => (
        <TableLoans
            key={`pending-${refreshKey}`}
            refreshKey={refreshKey}
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            startDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_LOANS_TWO}
            status={0}
            hiddenFilterOptions={true}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    );
    
    const ComponentThree = useCallback(() => (
        <TableLoans
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            endDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_LOANS_THREE}
            status={1}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);

    
    return (
        <Grid  container >
            <ThreeComponent
                useTabsNameAsTitle={true}
                tabsTitle={["Solicitar", "Pendientes", "Histórico"]}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Grid>
    )

}

export default Loans